import React from "react";
import { connect } from "react-redux";
import {
  updateLetterSpacing,
  updateTransformType,
  updateTransformAmount,
  updateTextValue,
  updateFontSize,
  selectSingleElement,
  updateFont,
} from "../../../actions";
import { bindActionCreators } from "redux";
import TextInputField from "./TextInputField";
import SelectTypeface from "./SelectTypeface";
import TextSize from "./TextSize";
import LetterSpacing from "./LetterSpacing";
import TransformText from "./TransformText";
import AnchorPoints from "./AnchorPoints/";

class TextField extends React.Component {
  state = {
    expanded: false,
  };

  componentDidMount() {
    if (this.props.index === 0 && !this.props.textElement.is_selected) {
      this.onExpandText();
    }
  }

  // Collapse/expand the color set when the title is clicked
  toggleCollapsed = () => {
    this.setState((prevState) => {
      return { expanded: !prevState.expanded };
    });
  };

  onUpdateTransformType = (transform_type) => {
    const id = this.props.textElement.id;
    this.props.updateTransformType({
      id,
      transform_type,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  onUpdateTransformAmount = (transform_amount) => {
    const id = this.props.textElement.id;
    this.props.updateTransformAmount({
      id,
      transform_amount,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  onUpdateLetterSpacing = (letter_spacing) => {
    const id = this.props.textElement.id;
    this.props.updateLetterSpacing({
      id,
      letter_spacing,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  onUpdateText = (value) => {
    const id = this.props.textElement.id;
    this.props.updateTextValue({
      id,
      value,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  onUpdateSize = (value) => {
    const id = this.props.textElement.id;
    this.props.updateFontSize({
      id,
      value,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  handleFontChange = (font) => {
    const id = this.props.textElement.id;
    this.props.updateFont({
      id,
      font,
      index: this.props.index,
      layerId: this.props.layerId,
    });
  };

  onExpandText = () => {
    const id = this.props.textElement.id,
      value = !this.props.textElement.is_selected;

    this.props.selectSingleElement({
      id,
      value,
      index: this.props.index,
      layerId: this.props.layerId,
      itemType: "TEXT",
    });
  };

  render() {
    const disabled = this.props.unifyText ? "disabled" : "enabled";

    const layer = this.props.design.layer_set[this.props.layerId];
    const allowed_font_categories = this.props.fonts.allowed_font_categories;

    const fontCategories = Object.values(this.props.fonts.categories).filter(
      (category) => {
        //check for special layer font restrictions
        if (layer.is_applique) {
          if (layer.character_type.length === 0) {
            //if no character type is specified, show all
            return category.is_applique;
          }
          return (
            category.is_applique &&
            layer.character_type.indexOf(category.character_type) !== -1
          );
        } else if (layer.is_repousse) {
          return category.is_foil_and_embossed;
        } else if (layer.is_stencil || layer.is_raised || layer.is_cutout) {
          if (layer.character_type.length === 0) {
            //if no character type is specified, show all
            return category.is_stencil;
          }
          return (
            category.is_stencil &&
            layer.character_type.indexOf(category.character_type) !== -1
          );
        }

        if (allowed_font_categories.length === 0) {
          //use the default categories
          return category.is_default;
        } else {
          return (
            allowed_font_categories.indexOf(parseInt(category.id, 10)) !== -1
          );
        }
      },
    );

    return (
      <div
        className={`tool__textfield collapsible ${this.props.textElement.is_selected || this.state.expanded ? "expanded" : "collapsed"}`}
      >
        <div
          className="collapsible__parent textfield__parent"
          onClick={this.onExpandText}
        >
          <h3 className="tool__section-header">
            {this.props.textElement.title ||
              this.props.textElement.text ||
              `Text Field ${this.props.index + 1}`}
          </h3>
        </div>

        <div className="collapsible__child">
          <TextInputField
            textValue={this.props.textElement.text}
            onUpdateText={this.onUpdateText}
          />

          <div className={`tool__typeface ${disabled}`}>
            <SelectTypeface
              allFonts={this.props.fonts.fonts}
              fontCategories={fontCategories}
              font={this.props.textElement.font}
              selectedValue={this.props.textElement.font.id}
              handleFontChange={this.handleFontChange}
            />

            <TextSize
              fontSize={this.props.textElement.size}
              allowedFontSizes={this.props.productOption.font_sizes}
              onUpdateSize={this.onUpdateSize}
            />
          </div>

          {/* {this.props.user.loggedIn && this.props.user.isAdmin && */}
          <AnchorPoints
            textElement={this.props.textElement}
            layerId={this.props.layerId}
            anchor_point={this.props.textElement.anchor_point}
          />
          {/* } */}

          <LetterSpacing
            letterSpacingAmt={this.props.textElement.letter_spacing}
            onUpdateLetterSpacing={this.onUpdateLetterSpacing}
          />

          <TransformText
            onUpdateTransformType={this.onUpdateTransformType}
            onUpdateTransformAmount={this.onUpdateTransformAmount}
            transformType={this.props.textElement.transform_type}
            transformAmount={this.props.textElement.transform_amount}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    productOption: state.productOption.entity,
    fonts: state.fonts,
    selectedElement: state.selectedElement,
    user: state.user,
    unifyText: state.unifyText.unifyText,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      updateLetterSpacing,
      updateTransformType,
      updateTransformAmount,
      updateTextValue,
      updateFontSize,
      selectSingleElement,
      updateFont,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TextField);
